<template id="objectDialog">
  <v-dialog eager persistent v-model="getDialog" max-width="1200">
      <v-card>
        <v-card-title class="headline">Object</v-card-title>
         <v-card-text>
            <h1>Bucket : {{dataChanged.bucket}}</h1>
        </v-card-text>
        <v-card-text>
            <v-text-field
              v-model="dataChanged.object"
              label="Object Name"
              outlined
            ></v-text-field>
        </v-card-text>
        <v-card-text >
            <vue-dropzone ref="objstore" id="dropzone"
            @vdropzone-complete="uploadComplete"
            @vdropzone-success="uploadSuccess"
            v-on:vdropzone-sending="sendingEvent"
            :options="dropzoneOptions"
            >
            </vue-dropzone>
        </v-card-text>
          <v-card-text v-if="dataChanged.url">
             Download Link : <a :href="dataChanged.url" target="_blank">{{dataChanged.object}}</a>
        </v-card-text>
        <v-card-actions>
          <v-btn class="dialog_btn" color="primary" text @click="upload">
            Upload
          </v-btn>
           <v-btn v-if="dataChanged.url" class="dialog_btn" color="primary" text @click="copy">
            Copy Link
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="darken-1"
            text
            @click.prevent="close()">
            close
          </v-btn>

        </v-card-actions>
      </v-card>
      <v-snackbar
        v-model="snackbar"
        color="info"
        :timeout="3000"
        :top="true"
      >
        {{ snakText }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar  v-model="error" color="error" :timeout="3000" top="top">
      {{errorMsg}}
    </v-snackbar>
    </v-dialog>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import conf from '@/config/config';

export default {
    id: "#objectDialog",
    props: {
      data : {
        type: Object,
        required: true,
        default: function(){
          return {
            dialogData : {}
          }
        }
      },
      dialog: {
        type: Boolean
      }
    },
     watch: {
       data: {
         handler(){
           //this.dataChanged = Object.assign({}, this.data);
         },
         deep: true
       }
    },
    data () {
      return {
        dataChanged: { bucket: null, object: null, url: null},
        dropzoneOptions: {
          url: conf.objstoreurl + '/api/object/upload',
          thumbnailWidth: 150,
          maxFilesize: 50,
          maxFiles: 1,
          //autoQueue: true,
          autoProcessQueue: false,
          autoDiscover: false,
          headers: {
            'Access-Control-Allow-Origin': '*'
          },
        },
        snakText: '',
        snackbar: false,
        errorMsg: '',
        error: false
      }
    },
    mounted: function() {
    console.log(this.$refs);
    },
    created() {
      //this.$refs.objstoreDropzone.removeAllFiles();
    },
    components: {
      vueDropzone: vue2Dropzone
    },
    computed: {
      getData() {
        return this.data || {};
      },
      getDialog(){
        return this.dialog;
      }
    },
    methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      copy: async function() {
        this.snakText = 'Copied.';
        this.snackbar = true;
        await navigator.clipboard.writeText(this.dataChanged.url);
      },
      removeAllFiles(){
            this.$refs.objstore.removeAllFiles(true);
      },
      manuallyAddFile(obj, item){
          this.$refs.objstore.manuallyAddFile(obj, item);
      },
      upload() {
         if(!this.dataChanged.bucket){
          this.errorMsg = "Bucket is not selected.";
          this.error = true;
          return;
        }

        if(!this.dataChanged.object){
           this.errorMsg = "Please set object name";
           this.error = true;
            return;
        }

        this.$refs.objstore.processQueue();
      },
      uploadSuccess(file, response){
        //console.log(file);
        console.log(response);
        if(response.ErrMsg == 'OK'){
          this.dataChanged.url = response.Data;
          this.$set(this.dataChanged, "url", response.Data);
          this.$emit('updateData', this.dataChanged);
        }else{
           this.errorMsg = response.ErrMsg;
          this.error = true;
        }
        // if(response.status == "success"){

        //   this.$emit('objectData', this.dataChanged);
        // }
      },
      uploadComplete(response){
        // if(response.status == "success"){

        //   this.$emit('objectData', this.dataChanged);
        // }
      },
      sendingEvent(file, xhr, formData){
        formData.append('object', this.dataChanged.object);
        formData.append('bucket', this.dataChanged.bucket);
      }
    }

  }
</script>
<style scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
}
.event_meta{
  margin-bottom: 15px !important;
}
.event_ok{
    color: #228a02 !important;
  }
  .event_error{
    color:#bd0303 !important;
  }

  .event_warning{
    color:#a9a400 !important;
  }

  .event_info{
    color: #20b8f2 !important;
  }
</style>


